import React from 'react';
import { cn } from '@/lib/utils';

export function IllustrativeLabel({ className }) {
  return (
    <p className={cn('text-[0.625rem] font-semibold uppercase tracking-[0.16em] text-[hsl(38_36%_42%)]/80', className)}>
      Illustrative preview
    </p>
  );
}

export function DemoPanel({ title, children, className, badge }) {
  return (
    <div className={cn('product-demo-panel', className)}>
      <div className="product-demo-panel__head">
        <p className="product-demo-panel__title">{title}</p>
        {badge ? <span className="product-demo-panel__badge">{badge}</span> : null}
      </div>
      <div className="product-demo-panel__body">{children}</div>
    </div>
  );
}

export function DemoSection({ id, eyebrow, title, copy, children, dark = false, className }) {
  return (
    <section id={id} className={cn('product-demo-section scroll-mt-24', dark && 'product-demo-section--dark', className)}>
      <div className="product-demo-section__intro">
        {eyebrow ? <p className="product-demo-eyebrow">{eyebrow}</p> : null}
        <h2 className="product-demo-heading">{title}</h2>
        {copy ? <p className="product-demo-copy">{copy}</p> : null}
      </div>
      <div className="product-demo-section__visual">{children}</div>
    </section>
  );
}

export function DemoPageShell({ children, className }) {
  return <div className={cn('product-demo-page', className)}>{children}</div>;
}
